<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    @submitFilters="setPageNumberAndSendRequest"
  >
    <template #title> لیست مشاوره ها </template>
    <template #filters>
      <SearchInput
        class="filters-width w-24"
        inputId="studentFullName"
        inputLabel="جستجو بر اساس نام زبان آموز"
        inputPlaceholder="علی..."
        v-model="supportListFilters.studentFullName"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>

      <SearchInput
        class="filters-width w-24"
        inputId="masterFullName"
        inputLabel="جستجو بر اساس نام استاد"
        inputPlaceholder="محمد..."
        v-model="supportListFilters.masterFullName"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>

      <RangeDatePicker
        class="w-24 filters-width"
        label="بازه‌ی تاریخ پشتیبانی را انتخاب کنید"
        @getDateRange="setDateRange"
      ></RangeDatePicker>
    </template>

    <CustomTable
      :pageNumber="supportListFilters.pageNumber"
      :count="supportListFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="supportList"
      @changePage="changePage"
    >
      <template #index="data">
        {{
          Math.ceil(
            data.index +
              1 +
              (supportListFilters.pageNumber - 1) * supportListFilters.count
          )
        }}
      </template>
      <template #fermanProfit="data">
        {{Intl.NumberFormat("en-US").format(Number(data.item.allPrice) - Number(data.item.allCounselPrice))}} تومان
      </template>
      <template #actions="data">
          <span
              class="btn p-0 m-0"
              v-b-tooltip="'مشاهده جزئیات'"
              @click="navigateToDetails(data.item.counselId)"
          >
            <feather-icon
                icon="ExternalLinkIcon"
                class="text-primary"
                size="20"
            />
          </span>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
import {BLink, VBTooltip} from "bootstrap-vue";

export default {
  mounted() {
    if (this.computedPageRouteQuery) {
      this.supportListFilters.pageNumber = this.computedPageRouteQuery;
    }

    this.getAllSupportList();
  },

  data() {
    return {
      isLoading: false,

      supportList: null,
      totalCount: null,
      queryDate: {
        startDate: null,
        endDate: null,
      },

      supportListFilters: {
        pageNumber: 1,
        count: 10,
        startDateTime: null,
        endDateTime: null,
        studentFullName: null,
        masterFullName: null,
      },

      tableColumns: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "counselId",
          label: "شناسه استاد",
        },
        {
          key: "counselName",
          label: "نام استاد",
        },
        {
          key: "allTime",
          label: "زمان مشاوره",
          formatter: (value) => `${value || 0} دقیقه`,
        },
        {
          key: "allCounselPrice",
          label: "درآمد استاد",
          formatter: (value) =>
              value ? `${Intl.NumberFormat("en-US").format(value)} تومان` : "-",
        },
        {
          key: "allPrice",
          label: "درآمد ناخالص فرمن",
          formatter: (value) =>
              value ? `${Intl.NumberFormat("en-US").format(value)} تومان` : "-",
        },
        {
          key: "fermanProfit",
          label: "سود فرمن",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },

  methods: {
    navigateToDetails(counselId){
      this.$router.push({
        path: `/support/list/${counselId}`,
        query: {
          studentFullName: this.supportListFilters.studentFullName,
          masterFullName: this.supportListFilters.masterFullName,
          startDateTime: this.queryDate.startDate,
          endDateTime: this.queryDate.endDate,
        },
      });
    },

    setPageNumberAndSendRequest() {
      this.supportListFilters.pageNumber = 1;
      this.setPageNumberQuery(1);
      this.getAllSupportList();
    },

    changePage(pageNumber) {
      this.supportListFilters.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
      this.getAllSupportList();
    },

    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: pageNumber,
        },
      });
    },

    async getAllSupportList() {
      try {
        this.isLoading = true;

        const _this = this;

        const getAllConsultList = new CounselingGroupCounselList(_this);
        getAllConsultList.setRequestParamDataObj(_this.supportListFilters);

        await getAllConsultList.fetch((res) => {
          if (res.isSuccess) {
            _this.supportList = res.data.data;
            _this.totalCount = res.data.total;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    setDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.supportListFilters.startDateTime = new Date(
          dateRange[0]
        ).toISOString();
        this.supportListFilters.endDateTime = new Date(
          dateRange[1]
        ).toISOString();

        //timeStamp for query
        this.queryDate.startDate = new Date(dateRange[0]).getTime()
        this.queryDate.endDate   = new Date(dateRange[1]).getTime()
      }
      else {
        this.supportListFilters.startDateTime = null;
        this.supportListFilters.endDateTime = null;
        this.queryDate.startDate = null;
        this.queryDate.endDate = null;
      }
    },
  },

  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.page) {
        return this.$route.query.page;
      }
      return null;
    },
  },
  directives: {
    BTooltip: VBTooltip,
  },
  components: {
    PageWrapper,
    CustomTable,
    SearchInput,
    RangeDatePicker,
    BLink,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";

import { CounselingGroupCounselList } from "@/libs/Api/Counseling";
</script>
